export const customRpc: Record<number, string> = {
  1: "https://eth.llamarpc.com", // Ethereum mainnet - replace unreliable eth.merkle.io
  8453: "https://base-mainnet.public.blastapi.io",
  42161: "https://arb1.arbitrum.io/rpc",
  59144: "https://rpc.linea.build",
  56: "https://bsc.publicnode.com",
};
